// ==========================================================================
// 1. スライダー（Swiper）の設定
// ==========================================================================
const setTopFvHeight = () => {
  const topMv = document.querySelector(".topMv");
  if (!topMv) return;

  const viewportHeight = window.visualViewport?.height || window.innerHeight;
  const viewportWidth = window.visualViewport?.width || window.innerWidth;
  document.documentElement.style.setProperty("--top-fv-height", `${viewportHeight}px`);
  document.documentElement.dataset.topFvWidth = String(Math.round(viewportWidth));
};

const updateTopFvHeightOnWidthChange = () => {
  const viewportWidth = Math.round(window.visualViewport?.width || window.innerWidth);
  if (document.documentElement.dataset.topFvWidth !== String(viewportWidth)) {
    setTopFvHeight();
  }
};

setTopFvHeight();
window.addEventListener("load", setTopFvHeight, { passive: true });
window.addEventListener("resize", updateTopFvHeightOnWidthChange, { passive: true });
window.addEventListener("orientationchange", () => {
  setTimeout(setTopFvHeight, 250);
});

document.addEventListener("DOMContentLoaded", () => {
  const topMvSwiper = new Swiper(".topMv__slide.swiper", {
    loop: true,
    speed: 1200,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 4000,
    },
  });

  const topBannerSwiper = new Swiper(".topBannerItems .swiper", {
    loop: true,
    speed: 1200,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 15,
    autoplay: {
      delay: 2400,
      // disableOnInteraction: false,
    },
    pagination: {
      el: ".topBannerItems .swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: '.topBannerItems .swiper-button-next',
      prevEl: '.topBannerItems .swiper-button-prev',
    },
    breakpoints: {
      651: {
        spaceBetween: 0,
        slidesPerView: 'auto',
      }
    },
  });


  const topServicesSlideCount = document.querySelectorAll(
    '.topServicesContent__slide .swiper-slide'
  ).length;

  const topServicesSlideLoop = topServicesSlideCount > 4;


  const topServicesContentSwiper = new Swiper(".topServicesContent__slide .swiper", {
    loop: true,
    speed: 1200,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: {
      delay: 2400,
      // disableOnInteraction: false,
    },
    pagination: {
      el: ".topServicesContent__slide .swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: '.topServicesContent__slide .swiper-button-next',
      prevEl: '.topServicesContent__slide .swiper-button-prev',
    },
    breakpoints: {
      651: {
        centeredSlides: false,
        slidesPerView: 4,
        loop: topServicesSlideLoop,
      }
    },
  });

  const topFeaturesSwiper = new Swiper(".topFeaturesItems__slide", {
    loop: true,
    speed: 1200,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: {
      delay: 2400,
      // disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.topFeaturesItems .swiper-button-next',
      prevEl: '.topFeaturesItems .swiper-button-prev',
    },
    pagination: {
      el: ".topFeaturesItems .swiper-pagination",
      clickable: true
    },
    breakpoints: {
      651: {
        centeredSlides: false,
        slidesPerView: 4,
      }
    },
  });
});

// ==========================================================================
// 2. スクロール時のヘッダー表示切り替え制御
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const scrollThreshold = 120;
  const checkScroll = () => {
    if (window.scrollY > scrollThreshold) {
      document.body.classList.add("is-scrolled");
    } else {
      document.body.classList.remove("is-scrolled");
    }
  };
  window.addEventListener("scroll", checkScroll, { passive: true });
  checkScroll();
});

// ==========================================================================
// 3. アクセスルートのタブ切り替え
// ==========================================================================
$(function () {
  const $accessRoutesTab = $('.accessRoutesTab');
  $accessRoutesTab.click(function () {
    if (!$(this).hasClass('is-active')) {
      $accessRoutesTab.removeClass('is-active');
      $(this).addClass('is-active');

      let tabTarget = '#route-' + $(this).data('target');
      console.log(tabTarget);
      $('.accessRoutesContent').removeClass('is-active');
      $(tabTarget).addClass('is-active');
    }
  });

});

// ==========================================================================
// 5. スムーススクロール
// ==========================================================================
$(function () {
  var urlHash = location.hash;
  // var w_width = $(window).width();
  var headerH = $('.header').innerHeight() + 20;

  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function () {
      var target = $(urlHash);
      var position = target.offset().top - headerH;
      $('body,html').stop().animate({
        scrollTop: position
      }, 500);
    }, 100);
  }


  $('a[href*="#"]').click(function () {
    var speed = 400;
    let headerHeight = $('.header').innerHeight() + 20;
    if ($('body').hasClass('page-id-146')) {

      //オプションページPCのとき
      if (window.matchMedia("(min-width: 651px)").matches) {
        headerHeight = headerHeight + $('.option__table thead').innerHeight();
      }
    }
    var href = $(this).attr('href');
    var href2 = href.substr(href.indexOf('#') + 1);

    var target;

    if (href.slice(0, 1) === "/") {
      href2 = "#" + href2;
      target = $(href2 == '#' || href2 == '' ? 'html' : href2);
    } else {
      target = $(href == '#' || href == '' ? 'html' : href);
    }

    var position = target.offset().top - headerHeight;
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');


    //ハンバーガーメニュー内の時はハンバーガーメニューを閉じる処理
    if ($(this).hasClass('headerPulldown__link') && $('.js-hm-btm').hasClass('open')) {
      $('.js-hm-btm').trigger('click');
    }

    return false;
  });

});


// ==========================================================================
// 6. ハンバーガーメニュー関連
// ==========================================================================

const $headerRight = $('.header__right');

$(window).on('load resize', function () {

  if (window.matchMedia("(max-width: 650px)").matches) {
    if (!$headerRight.hasClass('hm_open')) {
      $headerRight.css('visibility', 'hidden');
    }
  } else {
    $headerRight.removeAttr('style');
  }
});

$(function () {


  //ハンバーガーボタン
  $('.js-hm-btm').on('click', function () {
    $(this).toggleClass('open');

    if ($headerRight.hasClass('hm_open')) {
      $headerRight.removeClass('hm_open');
      setTimeout(function () {
        //ハンバーガーメニューの連続開閉で処理がずれないように
        if (!$headerRight.hasClass('hm_open')) {
          $headerRight.css('visibility', 'hidden');
        }
      }, 1000);
    } else {
      $headerRight.css('visibility', 'visible');
      $headerRight.addClass('hm_open');
    }
  });

  //ハンバーガーメニュー内のボタン展開
  $('.headerPulldown__head.has_child').on('click', function () {
    if ($headerRight.hasClass('hm_open')) {
      if ($(this).hasClass('open')) {
        $(this).removeClass('open');
        $(this).parent().removeClass('active');
        $(this).next().slideUp();
      } else {
        $('.headerPulldown__head.open').trigger('click');
        $(this).addClass('open');
        $(this).parent().addClass('active');
        $(this).next().slideDown();
      }

    } else {
      if (window.matchMedia("(min-width: 651px)").matches) {
        $(this).parent().toggleClass('active');
      }
    }
  });


  $('.headerPulldown__body').mouseout(function () {
    if (!$headerRight.hasClass('hm_open')) {
      if (window.matchMedia("(min-width: 651px)").matches) {
        $(this).parents('.headerPulldown').removeClass('active');
      }
    }
  });
});


// ==========================================================================
// 6. トップへ戻るボタンとSP追従ボタン
// ==========================================================================

$(window).on('load scroll', function () {
  var ftPosition = $('.footerData__copy').offset().top - 20,
    wHeight = $(window).height(),
    wtPosition = $(window).scrollTop(),
    wbPosition = wtPosition + wHeight;

  if (wtPosition < 80) {
    $('.btn_to_top').fadeOut();
    $('.sp_fixed_btns').fadeOut();
  } else if (wbPosition > ftPosition) {
    $('.btn_to_top').fadeOut();
    $('.sp_fixed_btns').fadeOut();
  } else {
    $('.btn_to_top').fadeIn();
    $('.sp_fixed_btns').fadeIn();
  }

});



$(function () {

  //FAQ
  $('.faqItem__ques').click(function () {
    $(this).toggleClass('open');
    $(this).next().slideToggle();
  });


  //検診コースのSPの
  if (window.matchMedia("(max-width: 650px)").matches) {
    $('.sp_accordion th').click(function () {
      $(this).toggleClass('open');
      $(this).next().toggleClass('open');
    });

  }

  //tabindex0
  $('*[tabindex="0"]').keypress(function (e) {
    if (e.keyCode == 13) {
      $(this).trigger('click');
      return false;
    }
  });

  function todaydate() {
    const today = new Date();

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const weekday = today.toLocaleDateString('ja-JP', { weekday: 'long' });

    const ymd = `${year}-${month}-${day}`;

    document.querySelectorAll('.o-schedule__headerDate--year').forEach(el => {
      el.textContent = year;
    });

    document.querySelectorAll('.o-schedule__headerDate--md').forEach(el => {
      el.textContent = `${month}.${day}`;
    });

    document.querySelectorAll('.o-schedule__headerDate--youbi').forEach(el => {
      el.textContent = weekday;
    });


    // ▼ 特定の日付での休診設定（文字列は ymd と完全一致させる）
    const specialClosedDates = [
      // "2026-07-16",
      // "2026-07-18",
      // "2026-07-19",
    ];

    // 休診日の設定
    const closedDays = [];

    const isSpecialClosed = specialClosedDates.includes(ymd);

    // 特定の日付、または休診曜日に該当するか
    const isClosed =
      isSpecialClosed ||
      closedDays.includes(weekday);

    document.querySelectorAll('.o-schedule__headerStatus').forEach(el => {
      const valueEl = el.querySelector('.o-schedule__headerStatus--value');

      if (valueEl) {
        valueEl.textContent = isClosed ? "休診日" : "診療日";
      }

      el.style.backgroundColor = isClosed ? "#8D8D8D" : "";
    });
  }

  todaydate();


});
